import React, { useEffect } from 'react'

export default function Radio({ object, handleFormData, formUse, data, prefilledData, viewOnly,rowIndex, colIndex }) {

    useEffect(() => {
        formUse && handleFormData && handleFormData(object.content+"-"+rowIndex+colIndex, "")
    }, [])

    return (
        <div className='d-flex flex-column gap-2' style={{ padding: "8px" }}>
            <label id={object.content + "-" + rowIndex + colIndex}>{object.content}</label>
            {object.options.map((option) => {
                return <div className='d-flex gap-3 align-items-center'>
                    <input type='radio' id={option.label+"-"+rowIndex+colIndex} name={object.content+"-"+rowIndex+colIndex}
                        checked={prefilledData && prefilledData[object?.content] ? prefilledData[object?.content] === option?.label : data && data[object.content+"-"+rowIndex+colIndex] === option.label}
                        value={option.label}
                        disabled={prefilledData && prefilledData[object?.content] ? true : viewOnly ? viewOnly : false}
                        onChange={(e) => handleFormData && handleFormData(object.content+"-"+rowIndex+colIndex, e.target.value)} /><label htmlFor={option.label+"-"+rowIndex+colIndex}>{option.label}</label>
                </div>
            })}
        </div>
    )
}
